// Capacity-band price ladder (per the spec sheet in image 1).
// Prices are quoted in **USD** at the source; the UI converts to the
// organizer's local currency at display time.
//
// Each band is half-open [from, to). The first band is the free tier.
export const CAPACITY_BANDS = [
  { tier: 'Free',       from: 0,    to: 300,   usd: 0 },
  { tier: 'Pro 1',      from: 300,  to: 1000,  usd: 30 },
  { tier: 'Pro 2',      from: 1000, to: 2000,  usd: 60 },
  { tier: 'Pro 3',      from: 2000, to: 3000,  usd: 90 },
  { tier: 'Pro 4',      from: 3000, to: 4000,  usd: 120 },
  { tier: 'Pro 5',      from: 4000, to: 5000,  usd: 150 },
  { tier: 'Pro 6',      from: 5000, to: 6000,  usd: 180 },
  { tier: 'Pro 7',      from: 6000, to: 7000,  usd: 210 },
  { tier: 'Pro 8',      from: 7000, to: 8000,  usd: 240 },
  { tier: 'Pro 9',      from: 8000, to: 9000,  usd: 270 },
  { tier: 'Pro 10',     from: 9000, to: 10000, usd: 300 },
  { tier: 'Enterprise', from: 10000, to: Infinity, usd: null }, // Contact sales
];

/**
 * Returns the band that matches a given participant count, or `null` if
 * the count is non-positive.
 */
export function bandForCapacity(capacity) {
  const n = Number(capacity);
  if (!Number.isFinite(n) || n <= 0) return null;
  return CAPACITY_BANDS.find((b) => n >= b.from && n < b.to) || null;
}
